export default {
    bridge: {
        name: "Bridge",
        url: "nwcg_reference/bridge",
    },
    fire_station: {
        name: "Fire Station",
        url: "nwcg_reference/fire_station",
    },
    gate: {
        name: "Gate",
        url: "nwcg_reference/gate",
    },
    landmark: {
        name: "Landmark",
        url: "nwcg_reference/landmark",
    },
    other: {
        name: "Other",
        url: "nwcg_reference/other",
    },
    value_at_risk: {
        name: "Value At Risk",
        url: "nwcg_reference/value_at_risk",
    },
}
